import StyledSvg from 'icons/StyledSvg';
import { IconProps } from 'icons/types';

export const ArrowLeft = ({ color, size = '24', height = '24' }: IconProps) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={height}
      color={color || 'currentColor'}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2886 4L16 4.71402L8.45121 11.9988L16 19.285L15.2885 19.999L7 11.9987L15.2886 4Z"
        fill="#0D0D0D"
      />
    </StyledSvg>
  );
};
